import React from "react";
import Heart1Icon from "$/valentine/heart-1.svg";
import Heart2Icon from "$/valentine/heart-2.svg";
import DesktopIcon from "$/valentine/desktop-heart.svg";
import { DeviceInfo } from "@/interface/deviceInfo";
import styles from "./background.module.scss";

interface BackgroundComponentProps {
  deviceInfo: DeviceInfo;
}

const BackgroundComponent: React.FC<BackgroundComponentProps> = ({ deviceInfo }) => {
  return (
    <div className={styles.bgIcons}>
      <div className={styles.iconsWrapper}>
        {deviceInfo?.isMobile ? (
          <>
            <div className={styles.top}>
              <Heart1Icon className={styles.topLeft} />
              <Heart1Icon className={styles.topRight} />
              <Heart2Icon className={styles.left} />
              <Heart1Icon className={styles.bottomLeft} />
              <Heart1Icon className={styles.bottomRight} />
            </div>
            <div className={styles.bottom}>
              <Heart2Icon className={styles.topLeft} />
              <Heart1Icon className={styles.bottomLeft} />
              <Heart2Icon className={styles.topRight} />
              <Heart1Icon className={styles.bottomRight} />
            </div>
          </>
        ) : (
          <DesktopIcon className={styles.desktop} />
        )}
      </div>
    </div>
  );
};

export default BackgroundComponent;
